import { normalizePathname } from '../utils/testable-utils';

export function setActiveNavigation(pathname = window.location.pathname) {
  const currentPage = normalizePathname(pathname);
  const links = document.querySelectorAll('.navigation__link[href]');

  links.forEach((link) => {
    const linkPage = normalizePathname(link.getAttribute('href'));
    const isActive = linkPage === currentPage;
    link.classList.toggle('is-active', isActive);

    if (isActive) {
      link.setAttribute('aria-current', 'page');
    } else {
      link.removeAttribute('aria-current');
    }
  });
}

export function enableArrowKeyNavigation() {
  document.querySelectorAll('.navigation__menu').forEach((menu) => {
    menu.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
        return;
      }

      const links = [...menu.querySelectorAll('.navigation__link')];
      const activeIndex = links.indexOf(document.activeElement);

      if (activeIndex === -1) {
        return;
      }

      event.preventDefault();
      let nextIndex = activeIndex;

      if (event.key === 'ArrowRight') {
        nextIndex = (activeIndex + 1) % links.length;
      } else if (event.key === 'ArrowLeft') {
        nextIndex = (activeIndex - 1 + links.length) % links.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = links.length - 1;
      }

      links[nextIndex].focus();
    });
  });
}
